var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerBuyout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 26.56C32.8432 26.56 38.3904 21.0128 38.3904 14.17C38.3904 7.32722 32.8432 1.78003 26.0004 1.78003C19.1575 1.78003 13.6104 7.32722 13.6104 14.17C13.6104 21.0128 19.1575 26.56 26.0004 26.56Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 26.56C32.8432 26.56 38.3904 21.0128 38.3904 14.17C38.3904 7.32722 32.8432 1.78003 26.0004 1.78003C19.1575 1.78003 13.6104 7.32722 13.6104 14.17C13.6104 21.0128 19.1575 26.56 26.0004 26.56Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6603 16.53C31.6403 16.29 31.5603 15.95 31.4203 15.53C31.2803 15.11 31.0703 14.75 30.8003 14.45C30.5303 14.15 30.1203 13.84 29.5903 13.51C29.0503 13.18 28.4003 12.92 27.6403 12.71L27.0203 12.55V8.9C27.3103 8.98 27.5603 9.15 27.7803 9.41C28.1103 9.79 28.2803 10.25 28.2903 10.8H31.1903C31.1103 9.47001 30.6503 8.45 29.8203 7.74C29.0803 7.11 28.1403 6.70001 27.0203 6.51V4.88H26.6003H25.4003H25.0003V6.49C23.8403 6.64 22.8503 7.04 22.0303 7.71C21.1203 8.46 20.6603 9.49001 20.6603 10.81C20.6603 11.46 20.7703 12.03 20.9903 12.5C21.2103 12.98 21.5303 13.36 21.9603 13.66C22.3903 13.96 22.8103 14.2 23.2303 14.37C23.6403 14.55 24.1503 14.71 24.7503 14.86C24.8403 14.88 24.9303 14.9 25.0003 14.93V19.21C24.5303 19.06 24.1303 18.8 23.8103 18.43C23.4003 17.96 23.2003 17.36 23.2203 16.62H20.3203C20.6103 19.64 22.1703 21.31 25.0003 21.66V23.44H25.4003H26.6003H27.0203V21.66C27.6303 21.59 28.1903 21.46 28.6903 21.26C29.3103 21.02 29.8003 20.74 30.1603 20.42C30.5203 20.1 30.8203 19.75 31.0703 19.36C31.3103 18.97 31.4803 18.62 31.5703 18.3C31.6603 17.98 31.7003 17.69 31.7003 17.43C31.6903 17.08 31.6803 16.78 31.6603 16.53ZM23.9703 11.57C23.6903 11.33 23.5503 10.98 23.5503 10.53C23.5503 9.99 23.7303 9.57001 24.0903 9.27001C24.3503 9.06001 24.6503 8.93 24.9903 8.87V12.06C24.5303 11.93 24.1903 11.77 23.9703 11.57ZM28.1303 18.74C27.8003 19 27.4203 19.17 27.0103 19.27V15.54C27.6103 15.73 28.0503 15.93 28.3103 16.15C28.6303 16.42 28.7903 16.82 28.7903 17.33C28.8003 17.93 28.5803 18.4 28.1303 18.74Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 32.1201C17.692 32.1201 21.0902 28.7219 21.0902 24.5301C21.0902 20.3382 17.692 16.9401 13.5002 16.9401C9.30832 16.9401 5.91016 20.3382 5.91016 24.5301C5.91016 28.7219 9.30832 32.1201 13.5002 32.1201Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 48.2201H1V40.0301C1 35.8501 4.39 32.4701 8.56 32.4701H18.44C22.62 32.4701 26 35.8601 26 40.0301V48.2201Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 32.1201C17.692 32.1201 21.0902 28.7219 21.0902 24.5301C21.0902 20.3382 17.692 16.9401 13.5002 16.9401C9.30832 16.9401 5.91016 20.3382 5.91016 24.5301C5.91016 28.7219 9.30832 32.1201 13.5002 32.1201Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 48.2201H4.25C2.45 48.2201 1 46.7601 1 44.9701V40.0301C1 35.8501 4.39 32.4701 8.56 32.4701H18.44C22.62 32.4701 26 35.8601 26 40.0301V48.2201V48.2201Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12988 48.2201V41.9401",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8701 48.2201V41.9401",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5002 32.1201C42.692 32.1201 46.0902 28.7219 46.0902 24.5301C46.0902 20.3382 42.692 16.9401 38.5002 16.9401C34.3083 16.9401 30.9102 20.3382 30.9102 24.5301C30.9102 28.7219 34.3083 32.1201 38.5002 32.1201Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48.2201H26V40.0301C26 35.8501 29.39 32.4701 33.56 32.4701H43.44C47.62 32.4701 51 35.8601 51 40.0301V48.2201Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5002 32.1201C42.692 32.1201 46.0902 28.7219 46.0902 24.5301C46.0902 20.3382 42.692 16.9401 38.5002 16.9401C34.3083 16.9401 30.9102 20.3382 30.9102 24.5301C30.9102 28.7219 34.3083 32.1201 38.5002 32.1201Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.75 48.2201H26V40.0301C26 35.8501 29.39 32.4701 33.56 32.4701H43.44C47.62 32.4701 51 35.8601 51 40.0301V44.9701C51 46.7701 49.54 48.2201 47.75 48.2201Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1299 48.2201V41.9401",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8701 48.2201V41.9401",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerBuyout);
export default __webpack_public_path__ + "static/media/PartnerBuyout.6764a1e9a3602befe03d2b0765c23bf5.svg";
export { ForwardRef as ReactComponent };